export const initDevTools = () => {
	window.VCDevTools = () =>
		import(/* webpackChunkName: "vc-dev-tools" */ './dev-tools').then(({ startVCDevTools }) =>
			startVCDevTools?.(),
		);
};
